<template>
  <ECurrency
    :initial-source-currency="sourceCurrency"
    :initial-target-currency="targetCurrency"
    v-bind="$props"
  />
</template>

<script>
export default {
  name: 'ECurrencyWrapper',
  components: {
    ECurrency: async () => import(
      /* webpackChunkName: "currency" */
      './widget.vue'
    ),
  },
  props: {
    sourceCurrency: {
      type: String,
      default: '',
    },
    targetCurrency: {
      type: String,
      default: '',
    },
    amount: {
      type: Number,
      default: 0,
    },
  },
};
</script>
